import { render } from "./PrimaryDetails.vue?vue&type=template&id=5614fb1b"
import script from "./PrimaryDetails.vue?vue&type=script&lang=js"
export * from "./PrimaryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__